import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import AdminTrialCartV0 from './versions/v0';
const versionSelect = ({ version, fields }) => {
    switch (version) {
        case 0:
            return _jsx(AdminTrialCartV0, { ...fields });
        default:
            throw new Error('Unknown module version');
    }
};
export default versionSelect;
//# sourceMappingURL=version-select.js.map